import { useLocation } from "react-router-dom";
import { Table, message, Spin } from "antd";
import type { ColumnsType } from "antd/es/table";
import Delivery from "./delivery";
import "./index.less";
import { useCallback, useEffect, useState } from "react";
import { commonApi, serviceApi } from "@/apis";

const OrderDetail = () => {
  const { search } = useLocation();
  const [mdm_unit, setMdm_unit] = useState<{ [key: string]: any }>({});
  const [delivery_type, setDelivery_type] = useState<{ [key: string]: any }>(
    {}
  );

  const [loading, setLoding] = useState(false);
  const [orderDetails, setOrderDetails] = useState<OrderDetails>();

  const getDictss = useCallback(() => {
    commonApi
      .getDictionaryList({
        dictTypeCodeList: ["mdm_unit", "delivery_type"],
      })
      .then((res) => {
        const _mdm_unit: { [key: string]: any } = {};
        const _delivery_type: { [key: string]: any } = {};
        (res.mdm_unit || []).forEach(({ dictCode, dictValue }) => {
          _mdm_unit[dictCode] = dictValue;
        });
        (res.delivery_type || []).forEach(({ dictCode, dictDesc }) => {
          _delivery_type[dictCode] = dictDesc;
        });
        setMdm_unit(_mdm_unit);
        setDelivery_type(_delivery_type);
      })
      .catch((error) => {
        message.error(error);
      });
  }, []);

  const getDetail = useCallback(async (id: string) => {
    try {
      setLoding(true);
      const details = await serviceApi.getOrderDetail({ id });
      setOrderDetails(details);
    } catch (error: any) {
      message.error(error);
    } finally {
      setLoding(false);
    }
  }, []);

  useEffect(() => {
    const query = new URLSearchParams(search);
    const id = query.get("id");
    if (id) {
      getDictss();
      getDetail(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns: ColumnsType<OrderProductListItems> = [
    {
      title: "商品名称",
      dataIndex: "productname",
      key: "productname",
      align: "center",
    },
    {
      title: "单位",
      dataIndex: "volumeUnit",
      key: "volumeUnit",
      align: "center",
      render: (volumeUnit) => <span>{mdm_unit[volumeUnit] || volumeUnit}</span>,
    },
    {
      title: "下单数量",
      dataIndex: "quantity",
      key: "quantity",
      align: "center",
    },
    {
      title: "希望送达日期",
      dataIndex: "deliverydate",
      key: "deliverydate",
      align: "center",
      render: (deliverydate) => (
        <span>{deliverydate || orderDetails?.deliverydate}</span>
      ),
    },
    {
      title: "实际签收数量",
      dataIndex: "podmg",
      key: "podmg",
      align: "center",
    },
  ];

  return (
    <Spin spinning={loading}>
      <div className="order-detail-wrapper">
        <ul className="detail-title">
          <li className="active">订单详情</li>
          <li>
            订单编号:<span>{orderDetails?.bstnk}</span>
          </li>
        </ul>
        <article className="detail-info-wrapper">
          <h4>基础信息</h4>
          <p className="info-item">
            下单时间:<span>{orderDetails?.createTime}</span>
          </p>
          <div className="flex-b-c detail-info-item-wrapper">
            <p className="info-item">
              收货人:<span>{orderDetails?.contact}</span>
            </p>
            <p className="info-item">
              联系电话:<span>{orderDetails?.tel}</span>
            </p>
            <p className="info-item">
              储罐序列号:<span>{orderDetails?.ttsMakeNum}</span>
            </p>
          </div>
          <div className="flex">
            <p className="info-item" style={{ width: "40%" }}>
              配送方式:
              <span>{delivery_type[orderDetails?.deliverymode || ""]}</span>
            </p>
            <p className="info-item">
              收货地址:<span>{orderDetails?.address}</span>
            </p>
          </div>
        </article>
        <article className="detail-info-wrapper">
          <h4>商品清单</h4>
          <Table
            size="middle"
            className="order-detail-table"
            dataSource={orderDetails?.orderProductList || []}
            columns={columns}
            pagination={false}
          />
        </article>
        <article className="detail-info-wrapper">
          <h4>发货信息</h4>
          <Delivery
            crmOrderNo={orderDetails?.bstnk || ""}
            address={orderDetails?.address || ""}
          />
        </article>
      </div>
    </Spin>
  );
};

export default OrderDetail;
